// extracted by mini-css-extract-plugin
export default {"button":"QuickActionButtons_button__+7j4p","whiteGradientAnimation":"QuickActionButtons_whiteGradientAnimation__uNSTW","buttonActive":"QuickActionButtons_buttonActive__8S5yf"};